import type React from 'react';
import { useTranslation } from 'react-i18next';
import { MigrationCtaButton } from './MigrationCtaButton';
import { MigrationHelperText } from './MigrationHelperText';
import { MigrationStateLayout } from './MigrationStateLayout';

interface ApprovalPendingStateProps {
  isAdmin: boolean;
  isStarting: boolean;
  /** Sends the merchant back to the Shopify approval page it already has. */
  onResume: () => void;
  currencyNotice?: string;
}

/** The replacement exists; Shopify is waiting for the merchant to approve it. */
export const ApprovalPendingState: React.FC<ApprovalPendingStateProps> = ({
  isAdmin,
  isStarting,
  onResume,
  currencyNotice,
}) => {
  const { t } = useTranslation();

  return (
    <MigrationStateLayout
      tone="pending"
      status={t('settings.subscription.successFeeMigration.approvalPending.body')}
      currencyNotice={currencyNotice}
    >
      {isAdmin ? (
        <MigrationCtaButton
          label={t('settings.subscription.successFeeMigration.approvalPending.action')}
          onClick={onResume}
          isLoading={isStarting}
        />
      ) : (
        <MigrationHelperText>
          {t('settings.subscription.successFeeMigration.approvalPending.viewerHelper')}
        </MigrationHelperText>
      )}
    </MigrationStateLayout>
  );
};
